export default __webpack_public_path__ + "static/media/button talkback-8.f5c878b0.png";